export { LocatorConsent } from './consent';
export { StyledConsentContainer } from './consent.styles';
